import merge from 'lodash/merge'

export function numberToHuman (value, locale) {
  if (value == null || Number.isNaN(value)) return '-'
  const options = {
    maximumFractionDigits: value >= 1000 ? 0 : 2
  }

  return value.toLocaleString(locale, {
    ...options
  })
}

export function numberToDays (value, locale, options = {}) {
  if (value == null || Number.isNaN(value)) return '-'
  options = merge({
    maximumFractionDigits: 1
  }, options)

  return value.toLocaleString(locale, {
    ...options,
    style: 'unit',
    unit: 'day'
  })
}

export function numberToArea (value, locale, options = {}) {
  if (value == null || Number.isNaN(value)) return '-'
  options = merge({
    maximumFractionDigits: 1
  }, options)

  return value.toLocaleString(locale, {
    ...options,
    style: 'unit',
    unit: 'meter'
  }) + '²'
}

export function numberToCurrency (value, locale, options = {}) {
  if (value == null || Number.isNaN(value)) return '-'
  options = merge({
    maximumFractionDigits: value >= 1000 ? 0 : 2
  }, options)

  return value.toLocaleString(locale, {
    ...options,
    style: 'currency',
    currency: 'EUR'
  })
}

export function numberToCurrencyPerArea (value, locale, options = undefined) {
  if (value == null || Number.isNaN(value)) return '-'

  return `${numberToCurrency(value, locale, options)} / m²`
}

export function numberToPercentage (value, locale, options = { maximumFractionDigits: 1 }) {
  if (value == null || Number.isNaN(value)) return '-'

  return value.toLocaleString(locale, merge(options, {
    style: 'percent'
  }))
}
